module.exports = __webpack_public_path__ + "static/img/14010110.fe149fd9.png";